<template>
  <v-main class="pa-4" fluid>
    <v-row>
      <!-- <v-snackbar v-model="snackbar" :timeout="8000" top :color="color" >  {{text}}
        <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
      </v-snackbar> -->

      <v-snackbar v-model="alerta.activo" multi-line :vertical="true" top right :color="alerta.color" > 
        <strong> {{alerta.texto}} </strong>
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
        </template>
      </v-snackbar>



      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-h5 font-weight-bold"> Entradas </span>
            <v-spacer></v-spacer>
            <v-btn color="success" dark class="mr-2" @click="exportarInformacion()"> <v-icon>mdi-microsoft-excel</v-icon></v-btn>

            <v-btn color="primary"   dark class="mr-2"  @click="nuevaEntrada = true"> Nuevo </v-btn>
            <v-btn color="secondary" dark fab small  class="mr-2" @click="initialize()">  <v-icon>mdi-refresh</v-icon> </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row >
              <v-col cols="12" sm="4" md="3" lg="2">
                <v-autocomplete
                  :items="bodegas" 
                  v-model="bodegafiltro" 
                  item-text="nombre" 
                  item-value="idbodegas" 
                  label="Bodegas" 
                  dense filled 
                  hide-details 
                  return-object
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="4" md="2" lg="2" class="pb-0">
                <v-text-field
                  dense
                  v-model="inicio"
                  label="Fecha de inicio"
                  hide-details
                  type="date"
                  filled
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="4" md="2" lg="2" class="pb-0">
                <v-text-field
                  dense
                  v-model="fin"
                  label="Fecha de fin"
                  hide-details
                  type="date"
                  filled
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3">
                <v-btn color="info" @click="filtroFechas()"  class="mr-2"><v-icon>search</v-icon></v-btn>
                <v-btn color="accent" @click="initialize()" >Todo</v-btn>
              </v-col>

              <v-spacer></v-spacer>
              <v-col cols="12" md="4" lg="3">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  dense
                  hide-details
                  append-icon="mdi-magnify" 
                  v-model="search"
                  filled
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="entradas"
                  :height="tamanioPantalla"
                  fixed-header
                  hide-default-footer
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event"
                  :loading ="loading"
                  :search="search"
                  dense
                >
                  <template v-slot:item.FECHA_ENTRADA="{ item }">
                    {{ moment(item.FECHA_ENTRADA).format('LL') }}
                  </template>

                  <template v-slot:item.editar="{ item }">
                    <v-icon small class="mr-2" @click="editItem(item)"  color="blue">  mdi-pencil </v-icon>
                  </template>
                
                </v-data-table>

              </v-col>
            </v-row>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
        </v-card>

        <v-dialog v-model="nuevaEntrada" max-width="500px">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card class="pa-1">
              <v-toolbar flat class="">
                <div class="font-weight-black text-md-h6 text-xs-subtitle-1 "> {{  formTitle }}  </div>
                <v-spacer></v-spacer>
                <v-btn color="error" fab small elevation="1" @click="nuevaEntrada = false" ><v-icon>clear</v-icon></v-btn>
              </v-toolbar>

              <v-card-text class="pb-0">
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-autocomplete
                      v-model="producto"
                      :items="productos"
                      label="Producto"
                      return-object
                      item-text="nomart"
                      item-value="id"
                      :rules="[v => !!v || 'Campo requerido']"
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>
                  
                  <v-col cols="12" class="pb-0">
                    <v-autocomplete
                      :items="bodegas" 
                      v-model="bodega" 
                      item-text="nombre" 
                      item-value="idbodegas" 
                      label="bodegas" 
                      dense outlined 
                      return-object
                      :rules="[v => !!v || 'Campo requerido']"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="cant"
                      outlined
                      dense
                      type="number"
                      label="Cantidad"
                      :rules="[v => !!v || 'Campo requerido']"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      outlined
                      dense
                      v-model="fechaentr"
                      label="Fecha de entrada"
                      type="date"
                      :rules="[v => !!v || 'Campo requerido']"
                    ></v-text-field>
                  </v-col>
                </v-row>

              </v-card-text>
              
              <div class="mt-10"></div>

              <v-footer absolute >
                <v-spacer></v-spacer>
                <v-btn class="primary" @click="save()"> Guardar entrada </v-btn>
              </v-footer>

            </v-card>
          </v-form>
        </v-dialog>

      </v-col>
    </v-row>
  </v-main>
</template>


<script>
  import {mapActions, mapGetters} from 'vuex'
  import  metodos from '@/mixins/metodos.js';
  import moment from 'moment'

  import XLSX from 'xlsx'
  
  export default {
    mixins:[metodos],

    data: () => ({
      nombre: 'Entradas', 

      inicio:moment().subtract(1, 'months').startOf('month').format("YYYY-MM-DD"), 
      fin: moment().subtract('months').endOf('months').format("YYYY-MM-DD"),

      loading: true,
      longitud:5,
      page: 1,
      pageCount: 0,
      itemsPerPage: 80,
      search:'',
      entradas:[],
      headers: [
        { text: 'Nombre', align: 'left',sortable: false, value: 'NOMBRE_PRODUCTO'},
        { text: 'Cantidad',             value: 'CANTIDAD' },
        { text: 'Fecha de ingreso',     value: 'FECHA_ENTRADA' },
        { text: 'Bodega',               value: 'BODEGA' },
        // { text: 'Recibio',             value: 'usuario_recibio' }
      ],

      valid: true,
      search:'',
      nuevaEntrada: false,
      dialogDelete: false,
      categorias: [],
      editedIndex: -1,
      editedItem: {
        idlaboratorios:0,
        nomlab: '',
        estatus: 0,
      },
      defaultItem: {
        idlaboratorios:0,
        nomlab: '',
        estatus: 0,
      },

      productos:[],
      producto:null,
      cant:'',
      fechaentr:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      alerta: { activo: false, texto:'', color:'error' },
      bodegas:[],
      bodega:{idbodegas:null, nombre:''},
      bodegafiltro: { idbodegas:null, nombre:''}

    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva entrada' : 'Editar entrada'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    async created(){
      this.bodegas = await this.consultar_bodegas();
      this.productos = await this.consultar_productos();
      this.initialize()
    },

    methods:{
      ...mapActions('productos',['traerProductos','addImg','verEntrada']),

      initialize(){
        this.entradas= []

        this.$http.get('entradas.list').then(response =>{
          if(response == null){
            this.loading = false
            this.entradas = []
          }else{
            this.loading = false
            this.entradas = response.body
            this.longitud = this.entradas.length
          }

          for(const i in this.entradas){
            this.entradas[i].fechaentr = this.entradas[i].fechaentr
          }
        })

      },

      filtroFechas(){
        this.entradas= []

        var payload = {
          inicio: this.inicio,
          fin:    this.fin,
          idbodegas: !this.bodegafiltro ? 0 : this.bodegafiltro.idbodegas
        }
        this.$http.post('entradas.fecha',payload).then(response =>{
          if(response == null){
            this.loading = false
            this.entradas = []
          }else{
            this.loading = false
            this.entradas = response.body
            this.longitud = this.entradas.length
          }

          for(const i in this.entradas){
            this.entradas[i].fechaentr = this.entradas[i].fechaentr
          }
        })
      },

      editItem (item) {
        this.editedIndex = this.categorias.indexOf(item)
        this.editedItem = Object.assign({}, item)
        console.log(this.editedItem)
        for(const i in this.productos){
          if(this.productos[i].codigo == this.editedItem.codigo){
            this.producto = this.productos[i]
          }
        }
        this.cant      = this.editedItem.cant
        this.cant      = this.editedItem.cant
        this.fechaentr = this.editedItem.fechaentr
        this.nuevaEntrada = true
      },

      close () {
        this.nuevaEntrada = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },


      save () {
        if(this.$refs.form.validate()){
          this.editedItem.estatus == false ? 0 : 1

          if (this.editedIndex > -1) {
            
          } else {
            var payload = {
              codigo:     this.producto.codigo,
              idproductos: this.producto.id,
              cant:       this.cant,
              fechaentr:  (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
              idbodegas: this.bodega.idbodegas,
              recibio:   this.getdatosUsuario.idusuariosweb
            }

            this.$http.post('entradas.add', payload).then(response=>{
              console.log('entradas', response.body);
              this.$http.post('almacen.add', payload).then(response=>{
                this.alerta = { activo: true, color:'success', texto: "Entrada agregada correctamente" };
                this.initialize()
              })
            })
          }
          this.nuevaEntrada = false
        }
      },


      exportarInformacion() {
        this.exportToExcel(this.entradas, this.nombre)
      },


    },
  }
</script>





